export default "__VITE_ASSET__DoQIptZJ__"